<span class="badge">
  <span>Nested Badge</span>
  <span class="badge">10</span>
</span>
<span class="badge badge-sm">
  <span>Nested Badge Small</span>
  <span class="badge">10</span>
</span>
